import styled from 'styled-components'

const Bold = styled.b`
  color: #df4a64;
`

export default Bold
